<!-- <app-cookie>
 
</app-cookie> -->

<app-menu-container
  id="menu"
  [links]="links"
  [currentRoute]="currentRoute"
>

</app-menu-container>

<div
  class="main"
>
  <router-outlet></router-outlet>
</div>

<app-footer></app-footer>

<button
  #scrollToTop
  class="back-to-top"
  fxLayout="row"
  fxLayoutAlign="center center"
  (click)="triggerScrollTo('menu')"
  (window:scroll)="onScroll()"
>
  <img src="/assets/icons/arrow_up.svg" alt="">
</button>

<a
  [href]="'tel:' + agencyService.agency.phone"
  target="_blank"
  appGtagEvent
  eventCategory="contact"
  eventAction="click"
  eventLabel="phone_click"
  appFbqEvent="Lead"
  [customData]="{content_name: 'phone_click', content_category: 'click'}"
  class="mobile-phone-contact"
>
  <img
    src="/assets/icons/contact/phone.svg"
    alt=""
    class="phone-icon"
  >
</a>



// WEBPACK FOOTER //
// ./src/app/app.component.html